
import { Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';

// Import CMS layout
import CMSLayout from '@/components/cms/CMSLayout';
import Settings from '@/pages/cms/Settings';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

// Lazy load components to improve performance
const Dashboard = lazy(() => import('@/pages/cms/Dashboard'));
const ExhibitList = lazy(() => import('@/pages/cms/ExhibitList'));
const EditExhibit = lazy(() => import('@/pages/cms/EditExhibit'));
const TourList = lazy(() => import('@/pages/cms/TourList'));
const EditTour = lazy(() => import('@/pages/cms/EditTour'));
const MediaLibrary = lazy(() => import('@/pages/cms/MediaLibrary'));
const VisitorInfo = lazy(() => import('@/pages/cms/VisitorInfo'));


// Loading fallback with consistent design and identity
const LoadingFallback = () => (
  <div className="flex items-center justify-center h-full w-full p-8">
    <div className="text-center">
      <div className="animate-spin w-8 h-8 border-4 border-primary border-t-transparent rounded-full mx-auto mb-4"></div>
      <p className="text-muted-foreground">Loading content...</p>
      <p className="text-xs text-muted-foreground mt-2">Please wait, this may take a moment</p>
    </div>
  </div>
);

// Stable wrapper to prevent unmounts/remounts
const PageWrapper = ({ component: Component }: { component: React.ComponentType }) => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Component />
    </Suspense>
  );
};

// Ensure stable routes with no redirects - now protected by authentication
export const cmsRoutes = (
  <Route path="/cms" element={<ProtectedRoute><CMSLayout /></ProtectedRoute>}>
    <Route index element={<PageWrapper component={Dashboard} />} />
    <Route path="exhibits" element={<PageWrapper component={ExhibitList} />} />
    <Route path="exhibits/new" element={<PageWrapper component={EditExhibit} />} />
    <Route path="exhibits/edit/:id" element={<PageWrapper component={EditExhibit} />} />
    <Route path="tours" element={<PageWrapper component={TourList} />} />
    <Route path="tours/new" element={<PageWrapper component={EditTour} />} />
    <Route path="tours/edit/:id" element={<PageWrapper component={EditTour} />} />
    <Route path="media" element={<PageWrapper component={MediaLibrary} />} />
    <Route path="visitor-info" element={<PageWrapper component={VisitorInfo} />} />
    
    
    <Route path="settings" element={<PageWrapper component={Settings} />} />
    
    <Route path="users" element={
      <div className="p-6 bg-muted/20 rounded-lg border border-muted-foreground/10">
        <h2 className="text-xl font-medium mb-2">User Management</h2>
        <p className="text-muted-foreground">User management will be implemented in Phase 6</p>
      </div>
    } />
  </Route>
);
